import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Users, Edit3 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useFavoriteUsers } from '@/hooks/use-favorite-users';
import FavoriteUsersGrid from './FavoriteUsersGrid';
import EditFavoritesModal from './EditFavoritesModal';

const FavoriteUsersTab = () => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const { data: favorites = [], isLoading } = useFavoriteUsers();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="space-y-6"
    >
      {/* Header */}
      <div className="space-y-4">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <Users className="w-6 h-6 text-primary flex-shrink-0" />
            <div className="min-w-0 flex-1">
              <h2 className="text-xl font-bold text-foreground">Top Follows</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Your favorite users and their latest posts from the last 24 hours
              </p>
            </div>
          </div>
          
          <Button
            onClick={() => setIsEditModalOpen(true)}
            variant="outline"
            size="sm"
            className="flex items-center gap-2 flex-shrink-0"
          >
            <Edit3 className="w-4 h-4" />
            <span className="hidden sm:inline">Edit My Top Follows</span>
            <span className="sm:hidden">Edit</span>
          </Button>
        </div>
      </div>

      {/* Grid */}
      <FavoriteUsersGrid favorites={favorites} />

      {/* Edit Modal */}
      <EditFavoritesModal
        open={isEditModalOpen}
        onOpenChange={setIsEditModalOpen}
        favorites={favorites}
      />
    </motion.div>
  );
};

export default FavoriteUsersTab;